import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class TransportDocumentService {
    static getTransportDocuments(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`transport-documents?filter=${qs}`, pageNumber));
    }
    static fetchTransportDocument(oid) {
        return lastValueFrom(BaseService.get(`transport-documents/${oid}`));
    }
    static saveTransportDocument(dto) {
        return lastValueFrom(BaseService.save(`transport-documents`, dto));
    }
    static deleteTransportDocument(oid) {
        return lastValueFrom(BaseService.delete(`transport-documents/${oid}`));
    }
    static searchTransportDocumentCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`transport-documents-search-dropdown/${selfId}?search=${qs}`));
    }
    // ----------------------------------------------------------------------
    // Search Dropdown
    // ----------------------------------------------------------------------
    static searchTransportDocumentForSectionCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`transport-documents-for-section-search-dropdown/${selfId}?search=${qs}`));
    }
    static searchTransportDocumentForTransformCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`transport-documents-for-transform-search-dropdown/${selfId}?search=${qs}`));
    }
    // ----------------------------------------------------------------------
    // Transport Document Items
    // ----------------------------------------------------------------------
    static getTransportDocumentItems(transportDocumentId) {
        return lastValueFrom(BaseService.get(`transport-document-items/${transportDocumentId}`));
    }
    static saveTransportDocumentItem(dto) {
        //return lastValueFrom(BaseService.save<ITransportDocumentItem>(`transport-document-items`, dto));
        return lastValueFrom(BaseService.post(`transport-document-items`, dto));
    }
    static deleteTransportDocumentItem(oid) {
        return lastValueFrom(BaseService.delete(`transport-document-items/${oid}`));
    }
}
